// extracted by mini-css-extract-plugin
export var cardIcon = "_y-5";
export var cardIconUnframed = "_y-9";
export var checkboxCard = "_y-0";
export var checkboxCardSelected = "_y-4";
export var disabled = "_y-2";
export var interactive = "_y-1";
export var outerBorder = "_y-3";
export var spacerMedium = "_y-8";
export var spacerSmall = "_y-7";
export var spacerXsmall = "_y-6";